import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import { Appearance } from '@/models/UserPreference.js';
import { initAuthStore } from './initAuthStore';
import * as map from 'lodash/map';
import _extend from 'lodash/extend';
import { adminRoles, depotRoles, alarmCenterRoles, roles } from '@/models/Role';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default (vueAuth) => {

  return new Vuex.Store({
    plugins: [vuexLocal.plugin],
    state: {
      user: null,
      vehicle_object_type: null,
      contract_template: null,
    },
    mutations: {
      setUser(state, user) {
        state.user = user;

        return user;
      },
      updateUser(state, user) {
        state.user.assign(user);

        return user;
      },
      clearUser(state, user) {
        state.user = null

        return user;
      },
      setContractTemplate(state, contractTemplate) {
        state.contract_template = contractTemplate;

        return contractTemplate;
      },
      updateUserPreference(state, userPreference) {
        return _extend(state.user.preference, userPreference);
      },
    },
    modules: {
      auth: initAuthStore(vueAuth)
    },
    actions: {
      clearUser({ commit, state }) {
        commit('clearUser')
      },
      setUser({ commit, state }, user) {
        commit('setUser', user)
      },
      updateUser({ commit, state }, user) {
        commit('updateUser', user)
      },
      setContractTemplate({ commit, state }, contractTemplate) {
        commit('setContractTemplate', contractTemplate)
      },
      setAppearance({ commit, state }, appearance) {

        if (state.user) {
          commit('updateUserPreference', {
            appearance: appearance
          })
        }

        document.body.className = appearance;
      },
      updateUserPreference({ commit, state }, userPreference) {
        commit('updateUserPreference', userPreference);
      },
    },
    getters: {
      vehicleObjectType: state => {
        return state.vehicle_object_type;
      },
      user: state => {
        return state.user;
      },
      userPreference: state => {
        return state.user?.preference;
      },
      language: state => {
        return state?.user?.preference?.language?.iso_3166_2;
      },
      hasFrontendAccess: state => {
        return state.user?.has_frontend_access;
      },
      contractColumns: state => {
        return state.user?.preference?.contract_columns;
      },
      contractColumnDict: state => {
        const contract_columns = state.user?.preference?.contract_columns;
        const dict = {};

        if (!contract_columns) return dict;

        for (var i = 0; i < contract_columns.length; ++i)
          if (contract_columns[i] !== undefined) dict[contract_columns[i]] = true;

        return dict;
      },
      vehicleColumns: state => {
        return state.user?.preference?.vehicle_columns;
      },
      vehicleColumnDict: state => {
        const vehicle_columns = state.user?.preference?.vehicle_columns;
        const dict = {};

        if (!vehicle_columns) return dict;

        for (var i = 0; i < vehicle_columns.length; ++i)
          if (vehicle_columns[i] !== undefined) dict[vehicle_columns[i]] = true;

        return dict;
      },
      appearance: state => {
        return state.user?.preference ? state.user.preference.appearance : Appearance.DEFAULT;
      },
      client: state => {
        return state.user?.client;
      },
      contractTemplates: state => {
        return state.user?.client ? state.user.client.contract_templates : [];
      },
      clients: state => {
        return state.user?.clients ? state.user.clients : [];
      },
      clientsOptions: (state, getters) => {
        if (!getters.user || !getters.user.clients) return [];

        return getters.user.clients.map(item => ({ value: item.id, text: item.company.name }));
      },
      contractTemplateOptions: (state, getters) => {

        if (!getters.contractTemplates) return [];

        return getters.contractTemplates.map(item => ({ value: item.id, text: item.name }));
      },
      contractTemplate: (state, getters) => {
        return state.contract_template;

        // const contractTemplates = getters.contractTemplates;

        // if (!contractTemplates) {
        //   return null;
        // }

        // const preference = getters.userPreference;

        // if (preference?.contract_template_id) {
        //   return contractTemplates.find(item => item.id == preference.contract_template_id)
        // } else {
        //   // return contractTemplates.find(item => item != null)
        // }
      },
      isAdmin: state => {
        const userRoles = map(state.user.roles, 'type')
        return userRoles.some(r => adminRoles.includes(r))
      },
      hasDepotRole: state => {
        const userRoles = map(state.user.roles, 'type')
        return userRoles.some(r => depotRoles.includes(r))
      },
      hasAlarmCenterRole: state => {
        const userRoles = map(state.user.roles, 'type')
        return userRoles.some(r => alarmCenterRoles.includes(r))
      },
      hasReadonlyRole: state => {
        return map(state.user.roles, 'type').includes(roles.ROLE_TYPE_ALARM_CENTER_READ_ONLY);
      },
      hasAdminReadonlyRole: state => {
        return map(state.user.roles, 'type').includes(roles.ROLE_TYPE_ADMIN_READ_ONLY);
      },
      isSenior: state => {
        const userRoles = map(state.user.roles, 'type')
        return userRoles.some(r => r === roles.ROLE_SENIOR)
      },
    }
  })
}
